module.exports = __webpack_public_path__ + "img/icon_avatar_bg@3x.cf421d15.png";